module.exports = __webpack_public_path__ + "img/grey_022.0eb26b92.png";